import { useMemo, useState } from 'react';
import { Button } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import { useFileUpload } from './useFileUpload';
import { UploadDialog } from './UploadDialog';

export function UploadButton() {
  const { uploadInput, fileUploadBody, fileUploadActions, isComplete, files } = useFileUpload({})
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  const handleUploadClick = () => {
    setUploadDialogOpen(true);
  };

  const handleUploadDialogClose = () => {
    setUploadDialogOpen(false);
  }

  const fileCount = files.length;
  const buttonLabel = fileCount > 0 ? `Upload (${fileCount})` : 'Upload'

  const uploadButton = useMemo(() => (
    <Button
      onClick={handleUploadClick}
      component="label"
      startIcon={<UploadIcon />}
      variant="outlined"
    >
      {buttonLabel}
      {uploadInput}
    </Button>
  ), [uploadInput, buttonLabel]);

  return (
    <>
      {uploadButton}

      <UploadDialog
        open={uploadDialogOpen}
        onClose={handleUploadDialogClose}
        fileUploadBody={fileUploadBody}
        fileUploadActions={fileUploadActions}
        isComplete={isComplete}
      />
    </>
  );
}
